import { setMeasurement, setTag, startInactiveSpan } from '@sentry/react'
import debug from 'debug'
import { useDispatch, useSelector } from 'react-redux'
import { selectIsVectorMap } from '../../store/map/map.selectors'
import { sendMapLoadingTime } from '../../store/map/mapSlice'
import { useEffectWithMapContext } from './MapContext'
import { isWebglSupported } from './map.utils'

const d = debug('map')

const useMapPerfMetrics = () => {
  const dispatch = useDispatch()
  const vectorMap = useSelector(selectIsVectorMap)

  useEffectWithMapContext(map => {
    const mapHasGoodSupport = isWebglSupported()
    if (d.enabled) d('goodSupport', mapHasGoodSupport)

    setTag('mapType', vectorMap ? 'vector' : 'raster')
    setTag('mapGoodSupport', String(mapHasGoodSupport))

    const startTimestamp = Date.now()
    map.once('load', () => {
      const endTimestamp = Date.now()
      const loadTime = endTimestamp - startTimestamp
      if (d.enabled) d('loadTime:', loadTime)
      setMeasurement('map.load', loadTime, 'second')
      dispatch(sendMapLoadingTime({ loadTime, mapHasGoodSupport }))
    })

    const spanMap = startInactiveSpan({
      name: 'map',
      forceTransaction: true
    })
    const spanMapStyle = startInactiveSpan({ name: 'style', parentSpan: spanMap })
    const spanMapLoad = startInactiveSpan({ name: 'load', parentSpan: spanMap })

    map.once('styledata', () => {
      spanMapStyle.end()
    })
    map.once('load', () => {
      spanMapLoad.end()
      spanMap.end()
    })
  }, [])
}

export default useMapPerfMetrics
